import * as models from '../../domain/models';
import { CurrencyEnum } from '../../../../shared/models';

export class OfferAddAndDidFormViewModel {
  sourcingRequestId: string = null;
  operatorId: string = null;
  aircraftId: number = null;
  offerPrice: number = null;
  legs: Array<models.LegRequest> = null;
  flightPrice?: number = null;
  quoteReferenceId: string = null;
  additionalInstructions: string = null;
  ownerAircraftApprovalAcquired?: boolean = null;
  currency: CurrencyEnum = null;
  creationType: models.CreationTypeEnum;
  elacPriceInfo: models.ElacPriceInfo;
  cancellationTermsType: models.CancellationTermsTypeEnum;
  partnerCommissionRate?: number = null;
  partnerCommissionFee?: number = null;

  isValid() {
    return !!this.operatorId && !!this.aircraftId && !!this.offerPrice;
  }
}
